import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

import type {
  QuoteListData,
  UseQuoteListParams,
  QuoteListQueryKey,
} from './types';
import { getQuoteListQueryKey } from './util';

export const useQuoteList: QueryFunction<
  QuoteListData,
  [UseQuoteListParams],
  QuoteListQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const queryKey = getQuoteListQueryKey(params);
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) => {
      const {
        query: { status, ...searchParams },
        shouldConvertQueryKeysToSnakeCase,
      } = params;

      return request(`/quotes/groups/${params.locator}`, {
        init: {
          method: 'GET',
          signal,
        },
        query: {
          ...searchParams,
          ...{ status },
        },
        shouldConvertQueryKeysToSnakeCase:
          shouldConvertQueryKeysToSnakeCase ?? true,
      });
    },
  });
};
